import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import BookingItemWeek from './BookingItemWeek';

function WeekView({ resources, bookings, startDate, onDayClick }) {
// console.log(`TCL -> WeekView.jsx:5 -> WeekView -> bookings:`, bookings)
// console.log(`TCL -> WeekView.jsx:5 -> WeekView -> resources:`, resources)


  // Generate 7 days starting from startDate
  const weekDays = Array.from({ length: 7 }, (_, index) => {
    const date = moment(startDate).add(index, 'days');
    return {
      day: date.format('ddd'),
      date: date.format('DD/MM'),
      fullDate: date.format('YYYY-MM-DD')
    };
  });

  const navigate = useNavigate();

  // Helper function to get bookings for a specific resource and date
  const getBookingsForCell = (resourceId, date) => {
    return bookings.filter(
      booking => booking.resourceId === resourceId && moment(booking.start).format('YYYY-MM-DD') === date
    );
  };

  const getBookingId = useCallback(booking => {
    const rawId = booking?._id ?? booking?.id ?? booking?.bookingId ?? booking?.eventId;
    return rawId ? String(rawId) : '';
  }, []);

  const handleBookingNavigate = useCallback(
    booking => {
      const bookingId = getBookingId(booking);
      if (!bookingId) return;
      navigate(`/schedule/details/${bookingId}`);
    },
    [getBookingId, navigate]
  );

  return (
    <div className="bg-white shadow-sm rounded-lg border border-gray-200">
      <div className="overflow-x-auto">
        <table className="min-w-full">
          {/* Table Header */}
          <thead className="bg-gray-50">
            <tr className="divide-x divide-gray-200">
              <th className="px-5 py-3 text-left text-sm font-semibold text-gray-900 sticky left-0 bg-gray-50 z-20 min-w-[100px] border-b border-gray-200">
                Resource
              </th>
              {weekDays.map((day, index) => (
                <th 
                  key={index} 
                  onClick={() => onDayClick(day.fullDate)}
                  className="px-3 py-3 text-center text-sm font-medium min-w-[130px] border-b border-gray-200 cursor-pointer hover:bg-gray-100 transition-colors"
                >
                  {day.day} {day.date}
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="bg-white">
            {resources.map((resource, rowIndex) => (
              <tr key={resource.id} className="divide-x divide-gray-200">
                <td className="px-6 py-2 text-sm font-medium text-gray-900 sticky left-0 bg-white z-10 whitespace-nowrap border-b border-gray-200">
                  {resource.name}
                </td>
                {weekDays.map((day, colIndex) => {
                  const cellBookings = getBookingsForCell(resource.id, day.fullDate);
                  // console.log(`TCL -> WeekView.jsx:57 -> WeekView -> cellBookings for date: ${day.fullDate}`, cellBookings);
                  return (
                    <td key={colIndex} className="px-3 py-4 text-sm border-b border-gray-200 overflow-visible">
                      <div className="flex flex-col items-center gap-2 relative">
                        {cellBookings.map((booking, idx) => {
                          const bookingKey = getBookingId(booking) || `${resource.id}-${day.fullDate}-${idx}`;
                          return (
                            <div
                              key={bookingKey}
                              className="w-full cursor-pointer"
                              onClick={() => handleBookingNavigate(booking)}
                            >
                              <BookingItemWeek booking={booking} />
                            </div>
                          );
                        })}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default WeekView;
